/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptOffer200,
  AddOfferLine200,
  AddOfferLineRequest,
  ApproveOffer200,
  CancelOffer200,
  CreateOffer200,
  CreateOfferRequest,
  DeactivateOffer200,
  Expire200,
  GetOffer200,
  GetOfferHistory200,
  GetOfferPdf200,
  Offer,
  OfferLine,
  PagedResponseOffer,
  RejectOffer200,
  RejectOfferRequest,
  RemoveOfferLine200,
  ReturnOfferToDraft200,
  SaveOfferLines200,
  SaveOfferLinesRequest,
  SearchOffersParams,
  SendOffer200,
  UpdateOffer200,
  UpdateOfferLine200,
  UpdateOfferLineRequest,
  UpdateOfferRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List an offer's lines (visible to whoever owns this copy)
 */
export const listOfferLines = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<OfferLine[]>(
      {url: `/api/v1/offers/${id}/lines`, method: 'GET', signal
    },
      );
    }
  



export const getListOfferLinesQueryKey = (id?: string,) => {
    return [
    `/api/v1/offers/${id}/lines`
    ] as const;
    }

    
export const getListOfferLinesQueryOptions = <TData = Awaited<ReturnType<typeof listOfferLines>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferLines>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOfferLinesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOfferLines>>> = ({ signal }) => listOfferLines(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOfferLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOfferLinesQueryResult = NonNullable<Awaited<ReturnType<typeof listOfferLines>>>
export type ListOfferLinesQueryError = unknown


export function useListOfferLines<TData = Awaited<ReturnType<typeof listOfferLines>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferLines>>,
          TError,
          Awaited<ReturnType<typeof listOfferLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferLines<TData = Awaited<ReturnType<typeof listOfferLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfferLines>>,
          TError,
          Awaited<ReturnType<typeof listOfferLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOfferLines<TData = Awaited<ReturnType<typeof listOfferLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferLines>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List an offer's lines (visible to whoever owns this copy)
 */

export function useListOfferLines<TData = Awaited<ReturnType<typeof listOfferLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOfferLines>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOfferLinesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Save all line changes (remove/update/add) in one transaction — only while DRAFT or REJECTED, partner's copy only
 */
export const saveOfferLines = (
    id: string,
    saveOfferLinesRequest: SaveOfferLinesRequest,
 ) => {
      
      
      return apiClient<SaveOfferLines200>(
      {url: `/api/v1/offers/${id}/lines`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveOfferLinesRequest
    },
      );
    }
  


export const getSaveOfferLinesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveOfferLines>>, TError,{id: string;data: SaveOfferLinesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveOfferLines>>, TError,{id: string;data: SaveOfferLinesRequest}, TContext> => {

const mutationKey = ['saveOfferLines'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveOfferLines>>, {id: string;data: SaveOfferLinesRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  saveOfferLines(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveOfferLinesMutationResult = NonNullable<Awaited<ReturnType<typeof saveOfferLines>>>
    export type SaveOfferLinesMutationBody = SaveOfferLinesRequest
    export type SaveOfferLinesMutationError = unknown

    /**
 * @summary Save all line changes (remove/update/add) in one transaction — only while DRAFT or REJECTED, partner's copy only
 */
export const useSaveOfferLines = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveOfferLines>>, TError,{id: string;data: SaveOfferLinesRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveOfferLines>>,
        TError,
        {id: string;data: SaveOfferLinesRequest},
        TContext
      > => {

      const mutationOptions = getSaveOfferLinesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Add a line to an offer — only while DRAFT or REJECTED, partner's copy only
 */
export const addOfferLine = (
    id: string,
    addOfferLineRequest: AddOfferLineRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddOfferLine200>(
      {url: `/api/v1/offers/${id}/lines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addOfferLineRequest, signal
    },
      );
    }
  


export const getAddOfferLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOfferLine>>, TError,{id: string;data: AddOfferLineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addOfferLine>>, TError,{id: string;data: AddOfferLineRequest}, TContext> => {

const mutationKey = ['addOfferLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOfferLine>>, {id: string;data: AddOfferLineRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addOfferLine(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddOfferLineMutationResult = NonNullable<Awaited<ReturnType<typeof addOfferLine>>>
    export type AddOfferLineMutationBody = AddOfferLineRequest
    export type AddOfferLineMutationError = unknown

    /**
 * @summary Add a line to an offer — only while DRAFT or REJECTED, partner's copy only
 */
export const useAddOfferLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOfferLine>>, TError,{id: string;data: AddOfferLineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addOfferLine>>,
        TError,
        {id: string;data: AddOfferLineRequest},
        TContext
      > => {

      const mutationOptions = getAddOfferLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List offers for the caller's organisation
 */
export const listOffers = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<Offer[]>(
      {url: `/api/v1/offers`, method: 'GET', signal
    },
      );
    }
  



export const getListOffersQueryKey = () => {
    return [
    `/api/v1/offers`
    ] as const;
    }

    
export const getListOffersQueryOptions = <TData = Awaited<ReturnType<typeof listOffers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOffers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOffersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOffers>>> = ({ signal }) => listOffers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOffersQueryResult = NonNullable<Awaited<ReturnType<typeof listOffers>>>
export type ListOffersQueryError = unknown


export function useListOffers<TData = Awaited<ReturnType<typeof listOffers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOffers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOffers>>,
          TError,
          Awaited<ReturnType<typeof listOffers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOffers<TData = Awaited<ReturnType<typeof listOffers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOffers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOffers>>,
          TError,
          Awaited<ReturnType<typeof listOffers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOffers<TData = Awaited<ReturnType<typeof listOffers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOffers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List offers for the caller's organisation
 */

export function useListOffers<TData = Awaited<ReturnType<typeof listOffers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOffers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOffersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new offer draft (partner's copy only — requires an active connection to the client)
 */
export const createOffer = (
    createOfferRequest: CreateOfferRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateOffer200>(
      {url: `/api/v1/offers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOfferRequest, signal
    },
      );
    }
  


export const getCreateOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOffer>>, TError,{data: CreateOfferRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOffer>>, TError,{data: CreateOfferRequest}, TContext> => {

const mutationKey = ['createOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOffer>>, {data: CreateOfferRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOffer(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOfferMutationResult = NonNullable<Awaited<ReturnType<typeof createOffer>>>
    export type CreateOfferMutationBody = CreateOfferRequest
    export type CreateOfferMutationError = unknown

    /**
 * @summary Create a new offer draft (partner's copy only — requires an active connection to the client)
 */
export const useCreateOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOffer>>, TError,{data: CreateOfferRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOffer>>,
        TError,
        {data: CreateOfferRequest},
        TContext
      > => {

      const mutationOptions = getCreateOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Send the offer to the client — partner only; requires APPROVED status
 */
export const sendOffer = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<SendOffer200>(
      {url: `/api/v1/offers/${id}/send`, method: 'POST', signal
    },
      );
    }
  


export const getSendOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOffer>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendOffer>>, TError,{id: string}, TContext> => {

const mutationKey = ['sendOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendOffer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sendOffer(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendOfferMutationResult = NonNullable<Awaited<ReturnType<typeof sendOffer>>>
    
    export type SendOfferMutationError = unknown

    /**
 * @summary Send the offer to the client — partner only; requires APPROVED status
 */
export const useSendOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOffer>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendOffer>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSendOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Undo internal approval, unlocking the offer for edits again — only from APPROVED
 */
export const returnOfferToDraft = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ReturnOfferToDraft200>(
      {url: `/api/v1/offers/${id}/return-to-draft`, method: 'POST', signal
    },
      );
    }
  


export const getReturnOfferToDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnOfferToDraft>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof returnOfferToDraft>>, TError,{id: string}, TContext> => {

const mutationKey = ['returnOfferToDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof returnOfferToDraft>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  returnOfferToDraft(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReturnOfferToDraftMutationResult = NonNullable<Awaited<ReturnType<typeof returnOfferToDraft>>>
    
    export type ReturnOfferToDraftMutationError = unknown

    /**
 * @summary Undo internal approval, unlocking the offer for edits again — only from APPROVED
 */
export const useReturnOfferToDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnOfferToDraft>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof returnOfferToDraft>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getReturnOfferToDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reject a sent offer — client only; partner may edit and re-send afterwards
 */
export const rejectOffer = (
    id: string,
    rejectOfferRequest: RejectOfferRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RejectOffer200>(
      {url: `/api/v1/offers/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectOfferRequest, signal
    },
      );
    }
  


export const getRejectOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOffer>>, TError,{id: string;data: RejectOfferRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectOffer>>, TError,{id: string;data: RejectOfferRequest}, TContext> => {

const mutationKey = ['rejectOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectOffer>>, {id: string;data: RejectOfferRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectOffer(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectOfferMutationResult = NonNullable<Awaited<ReturnType<typeof rejectOffer>>>
    export type RejectOfferMutationBody = RejectOfferRequest
    export type RejectOfferMutationError = unknown

    /**
 * @summary Reject a sent offer — client only; partner may edit and re-send afterwards
 */
export const useRejectOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOffer>>, TError,{id: string;data: RejectOfferRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectOffer>>,
        TError,
        {id: string;data: RejectOfferRequest},
        TContext
      > => {

      const mutationOptions = getRejectOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Manually mark a sent offer as expired (own copy only)
 */
export const expire = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Expire200>(
      {url: `/api/v1/offers/${id}/expire`, method: 'POST', signal
    },
      );
    }
  


export const getExpireMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expire>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof expire>>, TError,{id: string}, TContext> => {

const mutationKey = ['expire'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof expire>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  expire(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExpireMutationResult = NonNullable<Awaited<ReturnType<typeof expire>>>
    
    export type ExpireMutationError = unknown

    /**
 * @summary Manually mark a sent offer as expired (own copy only)
 */
export const useExpire = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expire>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof expire>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getExpireMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Cancel an offer the partner has abandoned — partner only, outside DRAFT and terminal statuses
 */
export const cancelOffer = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CancelOffer200>(
      {url: `/api/v1/offers/${id}/cancel`, method: 'POST', signal
    },
      );
    }
  


export const getCancelOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOffer>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelOffer>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOffer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelOffer(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelOfferMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOffer>>>
    
    export type CancelOfferMutationError = unknown

    /**
 * @summary Cancel an offer the partner has abandoned — partner only, outside DRAFT and terminal statuses
 */
export const useCancelOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOffer>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOffer>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Internally approve a draft/rejected offer — required before it can be sent to the client
 */
export const approveOffer = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ApproveOffer200>(
      {url: `/api/v1/offers/${id}/approve`, method: 'POST', signal
    },
      );
    }
  


export const getApproveOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOffer>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveOffer>>, TError,{id: string}, TContext> => {

const mutationKey = ['approveOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveOffer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approveOffer(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveOfferMutationResult = NonNullable<Awaited<ReturnType<typeof approveOffer>>>
    
    export type ApproveOfferMutationError = unknown

    /**
 * @summary Internally approve a draft/rejected offer — required before it can be sent to the client
 */
export const useApproveOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOffer>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveOffer>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApproveOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Accept a sent offer — client only
 */
export const acceptOffer = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AcceptOffer200>(
      {url: `/api/v1/offers/${id}/accept`, method: 'POST', signal
    },
      );
    }
  


export const getAcceptOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOffer>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptOffer>>, TError,{id: string}, TContext> => {

const mutationKey = ['acceptOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptOffer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  acceptOffer(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptOfferMutationResult = NonNullable<Awaited<ReturnType<typeof acceptOffer>>>
    
    export type AcceptOfferMutationError = unknown

    /**
 * @summary Accept a sent offer — client only
 */
export const useAcceptOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOffer>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptOffer>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcceptOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single offer
 */
export const getOffer = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetOffer200>(
      {url: `/api/v1/offers/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetOfferQueryKey = (id?: string,) => {
    return [
    `/api/v1/offers/${id}`
    ] as const;
    }

    
export const getGetOfferQueryOptions = <TData = Awaited<ReturnType<typeof getOffer>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOffer>>> = ({ signal }) => getOffer(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOffer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOfferQueryResult = NonNullable<Awaited<ReturnType<typeof getOffer>>>
export type GetOfferQueryError = unknown


export function useGetOffer<TData = Awaited<ReturnType<typeof getOffer>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOffer>>,
          TError,
          Awaited<ReturnType<typeof getOffer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOffer<TData = Awaited<ReturnType<typeof getOffer>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOffer>>,
          TError,
          Awaited<ReturnType<typeof getOffer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOffer<TData = Awaited<ReturnType<typeof getOffer>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffer>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single offer
 */

export function useGetOffer<TData = Awaited<ReturnType<typeof getOffer>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOffer>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOfferQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update an offer's content (including client/object, OFF-NEW-55) — only while DRAFT or REJECTED, own copy only
 */
export const updateOffer = (
    id: string,
    updateOfferRequest: UpdateOfferRequest,
 ) => {
      
      
      return apiClient<UpdateOffer200>(
      {url: `/api/v1/offers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOfferRequest
    },
      );
    }
  


export const getUpdateOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOffer>>, TError,{id: string;data: UpdateOfferRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOffer>>, TError,{id: string;data: UpdateOfferRequest}, TContext> => {

const mutationKey = ['updateOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOffer>>, {id: string;data: UpdateOfferRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOffer(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOfferMutationResult = NonNullable<Awaited<ReturnType<typeof updateOffer>>>
    export type UpdateOfferMutationBody = UpdateOfferRequest
    export type UpdateOfferMutationError = unknown

    /**
 * @summary Update an offer's content (including client/object, OFF-NEW-55) — only while DRAFT or REJECTED, own copy only
 */
export const useUpdateOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOffer>>, TError,{id: string;data: UpdateOfferRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOffer>>,
        TError,
        {id: string;data: UpdateOfferRequest},
        TContext
      > => {

      const mutationOptions = getUpdateOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Remove a line from an offer — only while DRAFT or REJECTED, partner's copy only
 */
export const removeOfferLine = (
    id: string,
    lineId: string,
 ) => {
      
      
      return apiClient<RemoveOfferLine200>(
      {url: `/api/v1/offers/${id}/lines/${lineId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveOfferLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOfferLine>>, TError,{id: string;lineId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeOfferLine>>, TError,{id: string;lineId: string}, TContext> => {

const mutationKey = ['removeOfferLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOfferLine>>, {id: string;lineId: string}> = (props) => {
          const {id,lineId} = props ?? {};

          return  removeOfferLine(id,lineId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveOfferLineMutationResult = NonNullable<Awaited<ReturnType<typeof removeOfferLine>>>
    
    export type RemoveOfferLineMutationError = unknown

    /**
 * @summary Remove a line from an offer — only while DRAFT or REJECTED, partner's copy only
 */
export const useRemoveOfferLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOfferLine>>, TError,{id: string;lineId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeOfferLine>>,
        TError,
        {id: string;lineId: string},
        TContext
      > => {

      const mutationOptions = getRemoveOfferLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a line's price/quantity — only while DRAFT or REJECTED, partner's copy only
 */
export const updateOfferLine = (
    id: string,
    lineId: string,
    updateOfferLineRequest: UpdateOfferLineRequest,
 ) => {
      
      
      return apiClient<UpdateOfferLine200>(
      {url: `/api/v1/offers/${id}/lines/${lineId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOfferLineRequest
    },
      );
    }
  


export const getUpdateOfferLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOfferLine>>, TError,{id: string;lineId: string;data: UpdateOfferLineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOfferLine>>, TError,{id: string;lineId: string;data: UpdateOfferLineRequest}, TContext> => {

const mutationKey = ['updateOfferLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOfferLine>>, {id: string;lineId: string;data: UpdateOfferLineRequest}> = (props) => {
          const {id,lineId,data} = props ?? {};

          return  updateOfferLine(id,lineId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOfferLineMutationResult = NonNullable<Awaited<ReturnType<typeof updateOfferLine>>>
    export type UpdateOfferLineMutationBody = UpdateOfferLineRequest
    export type UpdateOfferLineMutationError = unknown

    /**
 * @summary Update a line's price/quantity — only while DRAFT or REJECTED, partner's copy only
 */
export const useUpdateOfferLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOfferLine>>, TError,{id: string;lineId: string;data: UpdateOfferLineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOfferLine>>,
        TError,
        {id: string;lineId: string;data: UpdateOfferLineRequest},
        TContext
      > => {

      const mutationOptions = getUpdateOfferLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Soft-delete an offer (own copy only)
 */
export const deactivateOffer = (
    id: string,
 ) => {
      
      
      return apiClient<DeactivateOffer200>(
      {url: `/api/v1/offers/${id}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivateOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateOffer>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateOffer>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateOffer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateOffer(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateOfferMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateOffer>>>
    
    export type DeactivateOfferMutationError = unknown

    /**
 * @summary Soft-delete an offer (own copy only)
 */
export const useDeactivateOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateOffer>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateOffer>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivateOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Generate a basic PDF preview of the offer (OFF-05)
 */
export const getOfferPdf = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetOfferPdf200>(
      {url: `/api/v1/offers/${id}/pdf`, method: 'GET', signal
    },
      );
    }
  



export const getGetOfferPdfQueryKey = (id?: string,) => {
    return [
    `/api/v1/offers/${id}/pdf`
    ] as const;
    }

    
export const getGetOfferPdfQueryOptions = <TData = Awaited<ReturnType<typeof getOfferPdf>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferPdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferPdfQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOfferPdf>>> = ({ signal }) => getOfferPdf(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOfferPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOfferPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getOfferPdf>>>
export type GetOfferPdfQueryError = unknown


export function useGetOfferPdf<TData = Awaited<ReturnType<typeof getOfferPdf>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferPdf>>,
          TError,
          Awaited<ReturnType<typeof getOfferPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferPdf<TData = Awaited<ReturnType<typeof getOfferPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferPdf>>,
          TError,
          Awaited<ReturnType<typeof getOfferPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferPdf<TData = Awaited<ReturnType<typeof getOfferPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate a basic PDF preview of the offer (OFF-05)
 */

export function useGetOfferPdf<TData = Awaited<ReturnType<typeof getOfferPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferPdf>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOfferPdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary AUD-01/AUD-02: header change history for this offer copy (not line changes)
 */
export const getOfferHistory = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetOfferHistory200>(
      {url: `/api/v1/offers/${id}/history`, method: 'GET', signal
    },
      );
    }
  



export const getGetOfferHistoryQueryKey = (id?: string,) => {
    return [
    `/api/v1/offers/${id}/history`
    ] as const;
    }

    
export const getGetOfferHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getOfferHistory>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferHistoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOfferHistory>>> = ({ signal }) => getOfferHistory(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOfferHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOfferHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getOfferHistory>>>
export type GetOfferHistoryQueryError = unknown


export function useGetOfferHistory<TData = Awaited<ReturnType<typeof getOfferHistory>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferHistory>>,
          TError,
          Awaited<ReturnType<typeof getOfferHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferHistory<TData = Awaited<ReturnType<typeof getOfferHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferHistory>>,
          TError,
          Awaited<ReturnType<typeof getOfferHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOfferHistory<TData = Awaited<ReturnType<typeof getOfferHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary AUD-01/AUD-02: header change history for this offer copy (not line changes)
 */

export function useGetOfferHistory<TData = Awaited<ReturnType<typeof getOfferHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOfferHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable offer list for the main Offers list page
 */
export const searchOffers = (
    params?: SearchOffersParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseOffer>(
      {url: `/api/v1/offers/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchOffersQueryKey = (params?: SearchOffersParams,) => {
    return [
    `/api/v1/offers/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchOffersQueryOptions = <TData = Awaited<ReturnType<typeof searchOffers>>, TError = unknown>(params?: SearchOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOffers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchOffersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchOffers>>> = ({ signal }) => searchOffers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchOffersQueryResult = NonNullable<Awaited<ReturnType<typeof searchOffers>>>
export type SearchOffersQueryError = unknown


export function useSearchOffers<TData = Awaited<ReturnType<typeof searchOffers>>, TError = unknown>(
 params: undefined |  SearchOffersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOffers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOffers>>,
          TError,
          Awaited<ReturnType<typeof searchOffers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchOffers<TData = Awaited<ReturnType<typeof searchOffers>>, TError = unknown>(
 params?: SearchOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOffers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOffers>>,
          TError,
          Awaited<ReturnType<typeof searchOffers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchOffers<TData = Awaited<ReturnType<typeof searchOffers>>, TError = unknown>(
 params?: SearchOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOffers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable offer list for the main Offers list page
 */

export function useSearchOffers<TData = Awaited<ReturnType<typeof searchOffers>>, TError = unknown>(
 params?: SearchOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOffers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchOffersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




